module.exports = __webpack_public_path__ + "static/ActaHeadline-Book-a871a5f13ffd8e22b0c0ff3796f3d3d2.woff2";